/*
Klaviyo ID configurations for newsletter lists and Sign-up Forms in Checkout. 
"production" is for Klaviyo account "POC (Prod)" 
"qa" is for Klaviyo account "POC (QA)" 
*/
import { SHIPPING_COUNTRY_CODES } from "@/data/shipping-country-code"

export const klaviyoConfig = {
    newsletterList: {
        production: {
            [SHIPPING_COUNTRY_CODES.Japan]: "XENc8Y",
            default: "VDhsm9"
        },
        qa: {
            [SHIPPING_COUNTRY_CODES.Japan]: "SzQNYV",
            default: "SH6jxc"
        }
    },
    checkoutMembershipForm: {
        production: {
            en: "Rzsj8c",
            de: "SWtivg",
            fr: "UuZqXz",
            ja: "SBWh7G"
        },
        qa: {
            en: "VetL5S",
            de: "XiNqM4",
            fr: "T8WBhY",
            ja: "QZqsmz"
        }
    }
}
